const getUserToken = () => {
    const token = JSON.parse(localStorage.getItem('userData'))?.token
    if (token) {
        return token
    }
}

export { getUserToken }
